// extracted by mini-css-extract-plugin
module.exports = {"container":"TrendingTopics_container__3iqJq","item":"TrendingTopics_item__2ivqB","title":"TrendingTopics_title__2lzZd","image":"TrendingTopics_image__2q0_j"};